import { HttpClient, JSON_STRING, MHTTPCL } from "../../../services/http/http-client";
import { BOOKING_URL } from "../../../services/common-urls";

export const AddBookingService = {
  addPromoter: ({
    company_name,
    company_legalname,
    first_name,
    last_name,
    address1,
    city,
    postalcode,
    region,
    country,
    phone1,
    phone2,
    email1,
    vat_no,
    url1,
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'new_promoter_from_booking_wizard',
    company_name,
    company_legalname,
    first_name,
    last_name,
    address1,
    city,
    postalcode,
    region,
    country,
    phone1,
    phone2,
    email1,
    vat_no,
    url1,
  }),
  verifyPromoter: ({
    company_name,
    company_legalname,
    first_name,
    last_name, 
    city,
    country,
    email1,
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'verify_promoter',
    output: JSON_STRING,
    company_name,
    company_legalname,
    first_name,
    last_name, 
    city,
    country,
    email1,
  }),
  addContactToPromoter: ({
    contact_id
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'add_contact_to_promoter',
    contact_id
  }),

  bookingWizardArtistPage:(startrow)=>MHTTPCL.post(BOOKING_URL,{
    url:	"booking.pl",
    section	:"bookings",
    action	:"booking_wizard_artist_page",
    table_id	:"artist_table",
    epr	:"2",
    startrow	:startrow,

    output:JSON_STRING


  })


  

  
}